import { render, staticRenderFns } from "./application-list-title.vue?vue&type=template&id=a5a855cc&"
import script from "./application-list-title.vue?vue&type=script&lang=js&"
export * from "./application-list-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports